/* Wave 11 (Vania · 1 Oct) · landing page for Google's redirect.
   Google sends the user back to `${origin}/auth/google#id_token=...&state=...`.
   We parse the fragment, POST to /api/auth/google/exchange, and navigate the
   user to the stashed `state` destination (defaults to /app). */
import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { client } from "@/lib/api";

export default function GoogleCallback() {
  const [status, setStatus] = useState("signing you in…");

  useEffect(() => {
    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const idToken = params.get("id_token");
    const dest = decodeURIComponent(params.get("state") || "/app");
    if (!idToken) {
      setStatus("no token from google — try again.");
      toast.error("google sign-in didn't return a token");
      setTimeout(() => window.location.assign("/app/signin"), 1200);
      return;
    }
    client.post("/auth/google/exchange", { id_token: idToken })
      .then((r) => {
        toast.success("signed in");
        setStatus("you're in. taking you back…");
        window.location.assign(dest.startsWith("/") ? dest : "/app");
      })
      .catch((e) => {
        setStatus("sign-in failed. please try again.");
        toast.error(e?.response?.data?.detail || "could not sign in");
        setTimeout(() => window.location.assign("/app/signin"), 1400);
      });
  }, []);

  return (
    <div className="admin-force-light" style={{ minHeight: "100dvh", background: "#FDFBF7",
                                                  display: "grid", placeItems: "center",
                                                  color: "#1A1A30", fontFamily: "Poppins" }}
         data-testid="google-callback">
      <p style={{ fontSize: 15, textTransform: "lowercase" }}>{status}</p>
    </div>
  );
}
